import {API_URL, apiPut} from '../api'
import {ApiRes} from '../../types/api'
import {IVolumeLeague, ILeagueSlotId, IVolumeLeagueMarket, LeagueVisibility} from './list'

/**
 * PUT /v3/admin/volume-league — 부분 업데이트 (id 필수)
 * 전달된 필드만 변경됨.
 *
 * Updatable fields:
 *  - name
 *  - status (draft / active / paused / ended)
 *  - start_at, end_at
 *  - window_days
 *  - refresh_interval_sec
 *  - supported_exchanges  ([] 전달 시 "all exchanges" 로 초기화)
 *  - exchange_urls        (거래소명 → URL 맵, {} 전달 시 제거 / 키는 supported_exchanges 와 매칭)
 *  - prize_pool           ({ total_amount: 0, currency: '' } 전달 시 제거)
 *  - url_third_party      ('' 전달 시 제거)
 *  - sort_value           (0 전달 시 기본 newest-first 순서로 초기화)
 *  - slot_id              (언어별 Slot 식별자 { ko, en }, 표시 전용 · 선택)
 *  - visibility           (public | managers)
 *  - markets              (markets scope 리그의 집계 시장 목록 — 전체 교체)
 */
export interface IEditVolumeLeagueBody {
    id: number
    name?: string
    status?: IVolumeLeague['status']
    start_at?: string
    end_at?: string
    window_days?: number
    refresh_interval_sec?: number
    supported_exchanges?: string[]
    exchange_urls?: {[exchange: string]: string}
    prize_pool?: IVolumeLeague['prize_pool']
    url_third_party?: string
    sort_value?: number
    slot_id?: ILeagueSlotId
    mobile_slot_id?: ILeagueSlotId
    visibility?: LeagueVisibility
    markets?: IVolumeLeagueMarket[]
}

export const editVolumeLeague = async (data: IEditVolumeLeagueBody): Promise<ApiRes<IVolumeLeague>> => {
    return await apiPut(API_URL, 'admin/volume-league', data)
}
